import React, { useEffect, useState } from "react";
import api from "./api";
import { useParams, useNavigate } from "react-router-dom";

const ProductEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    api
      .get(`${process.env.REACT_APP_API_URL}/products/${id}`, { withCredentials: true })
      .then((res) => {
        const data = res.data;
        setForm({
          ...data,
          is_flagged: !!data.is_flagged,
          auction_platform: data.auction_platform
            ? Array.isArray(data.auction_platform)
              ? data.auction_platform
              : data.auction_platform.split(",")
            : [],
          auction_allegro_url: data.auction_allegro_url || "",
          auction_olx_url: data.auction_olx_url || "",
        });
      })
      .catch(() => setErrorMessage("❌ Nie udało się załadować danych produktu."));
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files, options, type, checked } = e.target;

    if (name === "images") {
      setForm((prev) => ({ ...prev, images: files }));
      return;
    }
    if (type === "checkbox" && name === "is_flagged") {
      setForm(prev => ({ ...prev, is_flagged: checked }));
      return;
    }
    if (name === "auction_platform") {
      const selected = Array.from(options).filter((o) => o.selected).map((o) => o.value);
      setForm((prev) => ({
        ...prev,
        auction_platform: selected,
        auction_allegro_url: selected.includes("allegro") ? prev.auction_allegro_url : "",
        auction_olx_url: selected.includes("olx") ? prev.auction_olx_url : "",
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageDelete = (imageUrl) => {
    const path = imageUrl.split("/storage/app/public/")[1];
    if (window.confirm("Czy na pewno usunąć to zdjęcie?")) {
      api
        .post("/images/delete", { path }, { headers: { "Content-Type": "application/json" } })
        .then(() => {
          setForm((prev) => ({
            ...prev,
            images: prev.images.filter((img) => img.full_url !== imageUrl),
          }));
        })
        .catch((err) => {
          console.error("Błąd usuwania zdjęcia:", err);
          alert("Błąd usuwania zdjęcia.");
        });
    }
  };

  const cleanFormData = (formData) => {
    const allowedFields = [
      "name", "catalog_number", "model", "location", "quantity", "unit", "price", "price_type",
      "description", "auction_platform", "auction_allegro_url", "auction_olx_url", "images","is_flagged"
    ];

    const cleaned = {};
    allowedFields.forEach((key) => {
      let val = formData[key];
      if (typeof val === "string") val = val.trim();
      if (val === null || val === undefined) val = "";
      if (key === "auction_platform" && Array.isArray(val)) {
        cleaned[key] = val.join(",");
      } else {
        cleaned[key] = val;
      }
    });

    return cleaned;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const cleaned = cleanFormData(form);
    const data = new FormData();

    Object.entries(cleaned).forEach(([key, val]) => {
      if (key === "images") {
  for (let i = 0; i < val.length; i++) {
    if (val[i] instanceof File) {
      data.append("images[]", val[i]);
    }
  }
  } else if (key === "is_flagged") {
    data.append("is_flagged", cleaned.is_flagged ? 1 : 0);
    }
      else {
        data.append(key, val);
      }
    });

    api
      .post(`${process.env.REACT_APP_API_URL}/products/${id}?_method=PUT`, data, { withCredentials: true })
      .then(() => {
        setSuccessMessage("✅ Produkt zaktualizowany pomyślnie.");
        setTimeout(() => navigate("/products"), 1500);
      })
      .catch(() => {
        setErrorMessage("❌ Wystąpił błąd podczas aktualizacji produktu.");
        setTimeout(() => setErrorMessage(""), 4000);
      });
  };

  if (!form) return <div className="p-4">Wczytywanie...</div>;

  return (
    <div className="container-xl py-4">
      <h2 className="mb-4">✏️ Edytuj produkt</h2>
      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-12 col-md-4">
            <label className="form-label"><i className="fas fa-tag me-2 text-secondary" /> Nazwa</label>
            <input name="name" className="form-control" value={form.name || ""} onChange={handleChange} />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label"><i className="fas fa-hashtag me-2 text-secondary" /> Nr katalogowy</label>
            <input name="catalog_number" className="form-control" value={form.catalog_number || ""} onChange={handleChange} />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label"><i className="fas fa-cogs me-2 text-secondary" /> Model</label>
            <input name="model" className="form-control" value={form.model || ""} onChange={handleChange} />
          </div>

          <div className="col-12 col-md-4">
            <label className="form-label"><i className="fas fa-warehouse me-2 text-secondary" /> St.M</label>
            <input name="location" className="form-control" value={form.location || ""} onChange={handleChange} />
          </div>
          <div className="col-6 col-md-4">
            <label className="form-label"><i className="fas fa-sort-numeric-up me-2 text-secondary" /> Ilość</label>
            <input type="number" name="quantity" className="form-control" value={form.quantity ?? 0} onChange={handleChange} min={0} onWheel={(e) => e.target.blur()} />
          </div>
          <div className="col-6 col-md-4">
            <label className="form-label"><i className="fas fa-ruler me-2 text-secondary" /> Jednostka</label>
            <select name="unit" className="form-select" value={form.unit || ""} onChange={handleChange}>
              <option value="">-- wybierz --</option>
              <option value="szt">szt</option>
              <option value="kpl">kpl</option>
            </select>
          </div>

          <div className="col-12 col-md-4">
            <label className="form-label"><i className="fas fa-money-bill-wave me-2 text-secondary" /> Cena</label>
            <input type="number" name="price" className="form-control no-spin" value={form.price ?? ""} onChange={handleChange} onWheel={(e) => e.target.blur()} />
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label"><i className="fas fa-balance-scale me-2 text-secondary" /> Typ ceny</label>
            <select name="price_type" className="form-select" value={form.price_type || "constant"} onChange={handleChange}>
              <option value="up">Cena w górę</option>
              <option value="down">Cena w dół</option>
              <option value="constant">Cena stała</option>
            </select>
          </div>
          <div className="col-12 col-md-4">
            <label className="form-label d-block">
              <i className="fas fa-flag me-2 text-danger" /> Oflaguj
            </label>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="is_flagged"
                name="is_flagged"
                checked={!!form.is_flagged}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="is_flagged">
                Wyróżnij na liście
              </label>
            </div>
          </div>

          {/* Aukcje */}
          <div className="col-12 col-md-4">
            <label className="form-label"><i className="fas fa-store me-2 text-secondary" /> Aukcje</label>
            <select name="auction_platform" className="form-select" value={form.auction_platform} multiple onChange={handleChange}>
              <option value="allegro">Allegro</option>
              <option value="olx">OLX</option>
            </select>
          </div>

          {form.auction_platform.includes("allegro") && (
            <div className="col-12 col-md-4">
              <label className="form-label"><i className="fab fa-algolia me-2 text-warning" /> Link do Allegro</label>
              <input name="auction_allegro_url" className="form-control" value={form.auction_allegro_url || ""} onChange={handleChange} />
            </div>
          )}

          {form.auction_platform.includes("olx") && (
            <div className="col-12 col-md-4">
              <label className="form-label"><i className="fas fa-store me-2 text-primary" /> Link do OLX</label>
              <input name="auction_olx_url" className="form-control" value={form.auction_olx_url || ""} onChange={handleChange} />
            </div>
          )}

          <div className="col-12 col-md-8">
            <label className="form-label"><i className="fas fa-align-left me-2 text-secondary" /> Opis</label>
            <textarea
              name="description"
              className="form-control"
              style={{ overflow: "hidden", resize: "none", minHeight: "100px" }}
              value={form.description || ""}
              onChange={handleChange}
              onInput={(e) => {
                e.target.style.height = "auto";
                e.target.style.height = `${e.target.scrollHeight}px`;
              }}
            />
          </div>

          {/* Zdjęcia */}
          {form.images?.length > 0 && !form.images?.[0]?.name && (
            <div className="col-12">
              <label className="form-label"><i className="fas fa-image me-2 text-secondary" /> Zdjęcia</label>
              <div className="d-flex flex-wrap gap-2">
                {form.images.map((img) => (
                  <div key={img.full_url} className="position-relative">
                    <img
                      src={img.full_url}
                      alt=""
                      className="img-thumbnail"
                      style={{ width: "100px", height: "100px", objectFit: "cover" }}
                    />
                    <button
                      type="button"
                      className="btn-close position-absolute top-0 end-0"
                      onClick={() => handleImageDelete(img.full_url)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className="col-12">
            <label className="form-label">Dodaj nowe zdjęcia (jpg)</label>
            <input type="file" name="images" className="form-control" multiple accept=".jpg" onChange={handleChange} />
          </div>

          <div className="col-12 d-flex justify-content-end gap-2">
            <button type="button" className="btn btn-secondary" onClick={() => navigate(`/products/${id}`)}>⬅️ Wróć do produktu</button>
            <button type="button" className="btn btn-secondary" onClick={() => navigate("/products")}>⬅️ Wróć do listy</button>
            <button type="submit" className="btn btn-primary">💾 Zapisz zmiany</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductEdit;
